import { Cell } from './grid';
export const defaultPassable = (c) => c === Cell.Floor;
/** Простий бінарний мін-хіп. Достатньо швидкий для сіток 31×13. */
class MinHeap {
    a = [];
    push(e) {
        this.a.push(e);
        let i = this.a.length - 1;
        while (i > 0) {
            const p = (i - 1) >> 1;
            if (this.a[p].f <= this.a[i].f)
                break;
            [this.a[p], this.a[i]] = [this.a[i], this.a[p]];
            i = p;
        }
    }
    pop() {
        if (this.a.length === 0)
            return undefined;
        const top = this.a[0];
        const last = this.a.pop();
        if (this.a.length > 0) {
            this.a[0] = last;
            let i = 0;
            const n = this.a.length;
            for (;;) {
                const l = i * 2 + 1, r = i * 2 + 2;
                let m = i;
                if (l < n && this.a[l].f < this.a[m].f)
                    m = l;
                if (r < n && this.a[r].f < this.a[m].f)
                    m = r;
                if (m === i)
                    break;
                [this.a[m], this.a[i]] = [this.a[i], this.a[m]];
                i = m;
            }
        }
        return top;
    }
    get size() { return this.a.length; }
}
const key = (c, r) => c * 100000 + r;
/**
 * Повертає шлях зі стартової клітинки до цілі (включно з обома кінцями)
 * або порожній масив, якщо шляху нема. Манхеттенська евристика.
 */
export function astar(start, goal, grid, passable = defaultPassable) {
    if (start.c === goal.c && start.r === goal.r)
        return [start];
    const open = new MinHeap();
    const came = new Map(); // child → parent (як ключ)
    const g = new Map();
    const startKey = key(start.c, start.r);
    g.set(startKey, 0);
    open.push({ c: start.c, r: start.r, f: heuristic(start, goal) });
    while (open.size > 0) {
        const cur = open.pop();
        if (cur.c === goal.c && cur.r === goal.r) {
            return reconstruct(came, cur, start);
        }
        const curKey = key(cur.c, cur.r);
        const curG = g.get(curKey) ?? Infinity;
        for (const [dc, dr] of NEIGHBORS) {
            const nc = cur.c + dc, nr = cur.r + dr;
            if (!passable(grid.get(nc, nr)))
                continue;
            const nKey = key(nc, nr);
            const tentative = curG + 1;
            if (tentative < (g.get(nKey) ?? Infinity)) {
                came.set(nKey, curKey);
                g.set(nKey, tentative);
                const f = tentative + heuristic({ c: nc, r: nr }, goal);
                open.push({ c: nc, r: nr, f });
            }
        }
    }
    return [];
}
const NEIGHBORS = [[1, 0], [-1, 0], [0, 1], [0, -1]];
function heuristic(a, b) {
    return Math.abs(a.c - b.c) + Math.abs(a.r - b.r);
}
function reconstruct(came, end, start) {
    const path = [{ c: end.c, r: end.r }];
    let curKey = key(end.c, end.r);
    const startKey = key(start.c, start.r);
    while (curKey !== undefined && curKey !== startKey) {
        const parentKey = came.get(curKey);
        if (parentKey === undefined)
            break;
        const pc = Math.floor(parentKey / 100000);
        const pr = parentKey - pc * 100000;
        path.push({ c: pc, r: pr });
        curKey = parentKey;
    }
    path.reverse();
    return path;
}
